<template>
  <div>
    <h5 class="mt-1 mb-3 text-headline-small">
      <v-icon :class="connectionStateIcon.class">{{ connectionStateIcon.name }}</v-icon>
      {{ props.vehicleInfo?.number_plate }}
    </h5>
    <div class="mb-4">
      <h6>{{ i18n.global.t('pages.vehicleInstall.map.infoWindow.dataTransmission.title') }}</h6>
      <v-card
        variant="flat"
        class="px-3 py-2 mb-2 bg-black text-light-green-accent-3 text-body-large"
      >
        {{ props.vehiclePosition?.time }}
      </v-card>
    </div>
    <div class="mb-2">
      <v-btn
        v-if="!vehicleAddress && props.vehiclePosition"
        variant = "flat"
        class="bg-grey-lighten-3"
        @click.stop="setVehicleAddress(props.vehiclePosition?.position)"
        :loading="isLoadingAddress"
      >
        {{ i18n.global.t('pages.vehicleInstall.map.infoWindow.getAddress') }}
      </v-btn>
      <v-card 
        v-else
        variant="flat"
        class="bg-grey-lighten-3 px-4 py-2"
      >
        {{ vehicleAddress }}
      </v-card>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import i18n from '@/lang/i18n';
import VehicleTimedPosition from '@/types/VehicleTimedPosition';
import getVehicleResponse from '@/types/responses/getVehicle';
import Coordinates from '@/types/Coordinates';
import { getAddress } from '@/services/Geocoder';
import { vehiclePositionSourceType as sourceType } from '@/services/consts';

const props = defineProps<{
  vehiclePosition: VehicleTimedPosition | null;
  vehicleInfo: getVehicleResponse | null;
}>();

const isLoadingAddress = ref(false);
const vehicleAddress = ref<string>('');

const connectionStateIcon = computed(() => {
  const s = props.vehiclePosition?.source;
  if (s === sourceType.SUBSCRIBED) {
    return {
      name: "mdi-signal-variant",
      class: "text-light-green-accent-4"
    }
  }
  return {
    name: "mdi-rss-off",
    class: "text-red-accent-3"
  }
});

async function setVehicleAddress(coord: Coordinates) {
  isLoadingAddress.value = true;

  if (vehicleAddress.value) {
    vehicleAddress.value = '';
  }

  try {
    const address = await getAddress(coord);
    if (address === null) {
      return;
    }
    vehicleAddress.value = address;
  } catch (e) {
    console.error(e)
    vehicleAddress.value = i18n.global.t('pages.vehicleInstall.errors.getAddress')
  } finally {
    isLoadingAddress.value = false;
  }
}

function clearVehicleAddress() {
  vehicleAddress.value = '';
}

defineExpose({
  clearVehicleAddress
});
</script>
